/**
 * 工单催办
 */
import { useState, useEffect, useRef } from 'react';
import { Form, Row, Col, message, Input, Spin, ConfigProvider, Radio } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import {SFuncModal} from "shj-components";
import {iiHOC} from "@/utils/auth.ts";
import {ticketsRemind} from "@/services/customerServices.ts";
const { TextArea } = Input;

export const ModalRemindWorkerOrderrTab = (props: any) => <ModalRemindWorkerOrderrDom {...props} />;

export function modalRemindWorkerOrderrFn(val: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `催办`,
    vanish: true,
    content: (
      <>
        <ConfigProvider locale={zhCN}>
          <ModalRemindWorkerOrderrDom onClose={onClose} {...val} />
        </ConfigProvider>
      </>
    ),
  });
  return dialog;
}

const ModalRemindWorkerOrderrDom = (params: any) => {
  const { onClose, fn, ids, issueId, formOnly } = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);

  useEffect(() => {}, []);
  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const onFinish = async() => {
    setLoading(true);
    try {
      let values = await form.validateFields();
      ticketsRemind({...values, ids}).then(res => {
        message.success(res.message || '操作成功');
        onClose?.();
        setLoading(false);
      })
    } catch (e) {
      setLoading(false);
    }
  };

  const onCancel = () => {
    onClose?.();
  };

  return iiHOC(
    <SFuncModal.Content
        onOk={onFinish}
        onCancel={onCancel}
        confirmLoading={loading}
    >
      <Spin spinning={spinLoading} tip="加载中...">
        <Form
          ref={formNode}
          form={form}
          onFinish={onFinish}
          {...{
            labelCol: {
              xs: { span: 12 },
              sm: { span: 6 },
            },
            wrapperCol: {
              xs: { span: 12 },
              sm: { span: 18 },
            },
          }}
        >
          <Row gutter={2}>
            <Col span={24}>
              <Form.Item label="" name="remindType" required rules={[{ required: true, message: '请选择' }]}>
                <Radio.Group>
                  <Radio value={1}>未首次跟进督促</Radio>
                  <Radio value={2}>周期跟进推送督促</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label="" name="remindContent" required>
                <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </SFuncModal.Content>,
  );
};
